
import { Routes, Route, Navigate } from 'react-router-dom';
import useSession from '@hooks/useSession';
import OattHeader from '@components/oatt-header/OattHeader';
import OattDashboardPage from './OattDashboardPage';
import OattUploadPage from './OattUploadPage';
// import OattComingSoon from './OattComingSoon';
import styles from './Oati.module.css';

import OattNspCoreInfoPage from '@pages/oatt-coreinfo/oatt-nsp-core-info/OattNspCoreInfoPage';
import OattComputationPage from './Oattcomputationpage';
import OattvalidationPage from './Oattvalidationpage';
import OattRevisionPage from '@pages/Oati/OattRevisionPage';
import OattInvoicePage from '@pages/Oati/OattInvoicesPage';
import OattAudit from '@pages/oatt-audit/OattAudit';
import { OattSessionProvider } from '@hooks/useOattSession';
import OattPointToPointPage from '@pages/oatt-coreinfo/rates/OattPointToPointPage';
import OattNetworkRatesPage from '@pages/oatt-coreinfo/rates/OattNetworkRatesPage';
import OattRatesPage from '@pages/oatt-coreinfo/rates/OattRatesPage';
import OattPeakConfigPage from '@pages/oatt-coreinfo/rates/OattPeakConfigPage';
import OattNspAndVendorInfoPage from '@pages/oatt-coreinfo/vendor-info/OattNspAndVendorInfoPage';
const OatiPage = () => {

  const { account, handleLogout, isOattBillPreparer, isOattBillApprover, isOattRateOwner, loading } = useSession();
  const rateOwnerFallback = <Navigate to="/oati/core-info" replace />;

  if (loading) return null;

  return (
    <OattSessionProvider>
      <div className={styles.oatiLayout}>
        <OattHeader account={account} onLogout={handleLogout} isOattBillPreparer={isOattBillPreparer} isOattBillApprover={isOattBillApprover} isOattRateOwner={isOattRateOwner} />

        <main className={styles.oatiContent}>
          <Routes>
            <Route path="upload" element={isOattRateOwner ? rateOwnerFallback : <OattUploadPage />} />
            <Route path="import" element={<Navigate to="/oati/dashboard" replace />} />
            <Route path="dashboard" element={isOattRateOwner ? rateOwnerFallback : <OattDashboardPage />} />
            <Route path="computation" element={isOattRateOwner ? rateOwnerFallback : <OattComputationPage />} />
            <Route path="validation" element={isOattRateOwner ? rateOwnerFallback : <OattvalidationPage />} />
            <Route path="audit" element={isOattRateOwner ? rateOwnerFallback : <OattAudit />} />
            <Route path="revision" element={isOattRateOwner ? rateOwnerFallback : <OattRevisionPage />} />
            <Route path="invoice" element={isOattRateOwner ? rateOwnerFallback : <OattInvoicePage />} />
            <Route path="core-info/rates" element={<OattRatesPage />} />
            <Route path="core-info/vendor-info" element={isOattBillPreparer || isOattBillApprover ? <OattNspAndVendorInfoPage /> : <Navigate to="/oati/dashboard" replace />} />
            <Route path="nsp-core-info" element={(isOattBillPreparer || isOattBillApprover) ? <OattNspCoreInfoPage readOnly={!isOattBillPreparer} /> : <Navigate to="/oati/dashboard" replace />} />
            <Route path="core-info/point-to-point" element={<OattPointToPointPage />} />
            <Route path="core-info/network" element={<OattNetworkRatesPage />} />
            <Route path="core-info/peak-config" element={<OattPeakConfigPage />} />
            <Route path="*" element={<Navigate to={isOattRateOwner ? '/oati/core-info/rates' : '/oati/dashboard'} replace />} />
            <Route path="*" element={<Navigate to="/oati/dashboard" replace />} />
          </Routes>
        </main>
      </div>
    </OattSessionProvider>
  );
};

export default OatiPage;